import React, { Component } from 'react'

import Grid from '@material-ui/core/Grid'
import TextField from '@material-ui/core/TextField'
import Paper from '@material-ui/core/Paper'

import './User.css'

class User extends Component {
    constructor(props) {
        super(props)
        this.state = {}
    }

    componentDidMount() {
        this.setState({ ...this.props.user })
    }

    onChangeField = (val, key) => {
        this.setState({ [key]: val })
    }

    render() {
        const variant = "outlined"

        return(
            <Paper className="user" square={true}>
                <Grid container={true} spacing={8}>
                    <Grid xs={12} item={true}>
                        <div className="field">
                            <TextField
                                value={this.state.id || ''}
                                label="ID"
                                variant={variant}
                                fullWidth={true}
                                disabled={true}
                            />
                        </div>
                    </Grid>
                </Grid>
            </Paper>
        )
    }
}

export default User



// WEBPACK FOOTER //
// ./src/components/User/User.js